import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function postRoutingProfileVehicleGroupsUnassign(
  routingProfileId: number,
  unassignIds: number[]
) {
  return fromFetch(
    new Request(
      `${fleetEnvironment.routingProfileVehicleGroupsUrl(
        routingProfileId
      )}/unassign`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify({
          vehicleGroupIds: unassignIds,
        }),
      }
    )
  ).pipe(ignoreData());
}
